<template>
  <div class="ai-image-generator">
    <h2>AI 绘图生成器喵~</h2>

    <div class="input-area">
      <textarea
        v-model="prompt"
        placeholder="输入绘图提示词，比如'一只可爱的猫娘'喵~"
      ></textarea>
      <button @click="generateImage" :disabled="isLoading">
        {{ isLoading ? "生成中..." : "生成图片喵~" }}
      </button>
    </div>

    <div class="result-area" v-if="imageUrl">
      <h3>生成结果喵~ (｡♥‿♥｡)</h3>
      <img :src="imageUrl" alt="AI生成的图片" class="generated-image" />
      <div class="action-buttons">
        <button @click="downloadImage" class="download-btn">保存图片喵~</button>
        <button @click="regenerate" class="regenerate-btn">再试一次喵~</button>
      </div>
    </div>

    <div class="error-message" v-if="errorMessage">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: "AIImageGenerator",
  data() {
    return {
      prompt: "",
      imageUrl: "",
      isLoading: false,
      errorMessage: "",
    };
  },
  methods: {
    async generateImage() {
      if (!this.prompt.trim()) {
        this.errorMessage = "请输入提示词喵~ (´･_･`)";
        return;
      }

      this.isLoading = true;
      this.errorMessage = "";
      this.imageUrl = "";

      try {
        const apiUrl = `https://image.pollinations.ai/prompt/${encodeURIComponent(
          this.prompt
        )}`;
        this.imageUrl = apiUrl; // 这个API直接返回图片URL喵~

        // 预加载图片
        await new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = resolve;
          img.onerror = reject;
          img.src = apiUrl;
        });
      } catch (error) {
        console.error("生成图片失败喵~:", error);
        this.errorMessage = "生成图片失败喵，请再试一次或换一个提示词 (╥﹏╥)";
      } finally {
        this.isLoading = false;
      }
    },
    downloadImage() {
      if (!this.imageUrl) return;

      this.isLoading = true;

      // 给文件名添加时间戳喵~
      const fileName = `ai-image-${Date.now()}.jpg`;

      // 使用fetch获取图片二进制数据喵~
      fetch(this.imageUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.blob();
        })
        .then((blob) => {
          // 创建下载链接喵~
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName;
          link.style.display = "none";

          document.body.appendChild(link);
          link.click();

          // 清理喵~
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 100);
        })
        .catch((error) => {
          console.error("下载失败喵~:", error);
          this.errorMessage = "下载图片失败喵，请稍后再试 (╥﹏╥)";
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    regenerate() {
      this.generateImage();
    },
  },
};
</script>

<style scoped>
.ai-image-generator {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: "Arial", sans-serif;
  position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

h2 {
  color: #ff6b9e;
  text-align: center;
  margin-bottom: 20px;
}

.input-area {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
}

textarea {
  padding: 10px;
  border: 2px solid #c0a0ff;
  border-radius: 8px;
  resize: vertical;
  font-size: 16px;
}

button {
  padding: 10px 15px;
  background-color: #c0a0ff;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

button:hover {
  background-color: #a080e0;
}

button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.result-area {
  margin-top: 30px;
  text-align: center;
}

h3 {
  color: #7a5dc7;
  margin-bottom: 15px;
}

.generated-image {
  max-width: 100%;
  max-height: 500px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 15px;
}

.download-btn {
  background-color: #6bd8ff;
}

.download-btn:hover {
  background-color: #4fb8e0;
}

.regenerate-btn {
  background-color: #ff8c6b;
}

.regenerate-btn:hover {
  background-color: #e06c4f;
}

.error-message {
  color: #ff4757;
  margin-top: 15px;
  text-align: center;
}
</style>
